var exports = {
  "AS": "item__mp7PZN",
  "O0": "itemLeadingVisual__1N9J6S",
  "Ir": "itemDescription__2zQKzu",
  "TN": "itemActions__Hy93fA",
  "H1": "prNumberButtonContainer__CQ61kK",
  "WB": "prNumberButton__oyRQfe",
  "_": "diffStatsContainer__jWg5ce",
  "hM": "diffStats__KZOyXU",
  "vi": "optimisticItem__CLh0J3",
  "mx": "attentionItem__1ACyOo",
  "ES": "shimmeringTitle__pMK6lo",
  "hE": "trailingIcons__cjOQd1",
  "A1": "typeIcon__F2bD2h",
  "Yx": "creatorAvatarColumn__ASPkpz",
  "Fr": "iconSkeleton__4aPnrL",
  "m9": "iconSkeletonWrapper__YrPCya",
  "Sq": "trailingActions__smFVN8",
};

module.exports = exports;
